module.exports = __webpack_public_path__ + "img/no_user_photo_2.5dddde6f.jpg";